import { render, staticRenderFns } from "./AffectItemGrid.vue?vue&type=template&id=e3346854"
import script from "./AffectItemGrid.vue?vue&type=script&lang=js"
export * from "./AffectItemGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports